var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.528 19.3773H6.47003C3.16388 19.3773 1.26172 17.4751 1.26172 14.169V7.82843C1.26172 4.52228 3.16388 2.62012 6.47003 2.62012H15.528C18.8341 2.62012 20.7363 4.52228 20.7363 7.82843V14.169C20.7363 17.4751 18.8341 19.3773 15.528 19.3773ZM6.47003 3.97881C3.87946 3.97881 2.62041 5.23786 2.62041 7.82843V14.169C2.62041 16.7595 3.87946 18.0186 6.47003 18.0186H15.528C18.1185 18.0186 19.3776 16.7595 19.3776 14.169V7.82843C19.3776 5.23786 18.1185 3.97881 15.528 3.97881H6.47003Z",
    fill: "#0195D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9979 11.7906C10.237 11.7906 9.46709 11.5551 8.87832 11.0751L6.04318 8.81057C5.75333 8.57507 5.69899 8.14934 5.93449 7.85949C6.17 7.56963 6.59572 7.51529 6.88558 7.7508L9.7207 10.0153C10.4091 10.5678 11.5776 10.5678 12.266 10.0153L15.1011 7.7508C15.391 7.51529 15.8258 7.56058 16.0522 7.85949C16.2877 8.14934 16.2424 8.58412 15.9435 8.81057L13.1084 11.0751C12.5287 11.5551 11.7587 11.7906 10.9979 11.7906Z",
    fill: "#0195D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailContact);
export default __webpack_public_path__ + "static/media/email-contact.54ce54a80d75c56ef321c96cdc0e9773.svg";
export { ForwardRef as ReactComponent };